import "./CouponSelection.scss";

import CouponSelectionItem from "./CouponSelectionItem";

export function CouponSelection({ selectionTitle, coupons, categoryId }) {
  const titleNode = categoryId ? (
    <a class="coupon-selection__title-link" href={`/category/${categoryId}`}>
      <h2 class="coupon-selection__title">{selectionTitle}</h2>
    </a>
  ) : (
    <h2 class="coupon-selection__title">{selectionTitle}</h2>
  );

  return (
    <div class="coupon-selection">
      {titleNode}
      <div class="coupon-selection__list">
        {coupons.map((coupon, index) => {
          return <CouponSelectionItem key={"sel-" + index} coupon={coupon} />;
        })}
      </div>
    </div>
  );
}
